<template lang="pug">
  .page.page--reset-password
    page-header.page-header--login(
      :breadcrumb-only="true"
      header-background="/img/frontend/page/page-header-default-background.jpg"
    )
    .container
      .auth-form.row.justify-content-center
        .col-12.col-md-8.col-lg-7.col-xl-6
          .auth-box
            .auth-box__header
              .row
                .col
                  h3.auth-box__header-title {{ trans('labels.frontend.passwords.forgot_password') }}
                .col-auto
                  i.fa-sign-in.auth-box__header-icon
            form(@submit='onSubmit($event)')
              .form-group
                label(for='email') {{ trans('labels.frontend.user.profile.email') }}
                input#email.form-control(v-model.trim='user.email', type='email', name='email', autocomplete='off', :placeholder="trans('labels.frontend.user.profile.email')")
              .form-group
                button.btn.btn-primary.btn-rounded.btn-block.btn-lg(type='submit', :disabled='loading.isLoggingIn || $v.$invalid')
                  span(v-if='!loading.isLoggingIn') {{ trans('labels.frontend.passwords.send_password_reset_link_button') }}
                  font-awesome-icon(v-if='loading.isLoggingIn', :icon="['far', 'circle-notch']", spin='')
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import BreadcrumbsManager from '../../mixins/BreadcrumbsManager';
import PageHeader from '../../components/layouts/PageHeader.vue';
import notify from '../../components/notify';

export default {
  components: {
    PageHeader,
  },
  mixins: [validationMixin, BreadcrumbsManager],
  data() {
    return {
      loading: {
        isLoggingIn: false,
      },
      user: {
        email: '',
      },
    };
  },
  validations: {
    user: {
      email: {
        required,
        email,
      },
    },
  },
  created() {
    this.setBreadcrumbs([
      { name: Lang.get('labels.frontend.passwords.forgot_password') },
    ]);
  },
  methods: {
    async onSubmit(event) {
      event.preventDefault();
      this.loading.isLoggingIn = true;
      notify.loading(this, { title: Lang.get('alerts.frontend.passwords.sending-reset-email'), text: Lang.get('alerts.general.please_wait') });
      try {
        await this.$store.dispatch('auth/reset_password', this.user);
        notify.clean(this).then(() => notify.success(this, {
          title: Lang.get('alerts.frontend.passwords.reset-email-sent'),
        }));
      } catch (err) {
        notify.clean(this).then(() => notify.errors(this, err));
      }
      this.loading.isLoggingIn = false;
    },
  },
  metaInfo: {
    // title: Lang.get('labels.frontend.passwords.forgot_password'),
  },
};
</script>
